<div class="myMenu">
  <span class="button-row">
    <button
      type="button"
      [matMenuTriggerFor]="tt"
      class="bet_time"
      mat-button
      class="white"
    >
      <mat-icon>format_list_bulleted</mat-icon>
      <div>Article</div>
    </button>

    <mat-menu #tt="matMenu">
      <button mat-menu-item routerLink="admin/article/0/1">Ajouter</button>
      <button mat-menu-item routerLink="admin/liste/article">Liste</button>
    </mat-menu>
  </span>
  <span class="button-row">
    <button
      routerLink="admin/categorie"
      type="button"
      class="bet_time"
      mat-button
      class="white"
    >
      <mat-icon>device_hub</mat-icon>
      <div>Catégorie</div>
    </button>
  </span>
  <span class="button-row">
    <button
      type="button"
      routerLink="admin/caracteristique"
      class="bet_time"
      mat-button
      class="white"
    >
      <mat-icon>playlist_add</mat-icon>
      <div>Caracteristiques</div>
    </button>
  </span>
  <span class="button-row">
    <button
      type="button"
      routerLink="admin/modelcaracteristique"
      class="bet_time"
      mat-button
      class="white"
    >
      <mat-icon>bookmark</mat-icon>
      <div>Modèle de caractéristiques</div>
    </button>
  </span>
  <span class="button-row">
    <button
      type="button"
      routerLink="admin/groupe/categorie"
      class="bet_time"
      mat-button
      class="white"
    >
      <mat-icon>device_hub</mat-icon>
      <div>Groupe catégories</div>
    </button>
  </span>
  <span class="button-row">
    <button
      type="button"
      routerLink="link"
      class="bet_time"
      mat-button
      class="white"
    >
      <mat-icon>screen_share</mat-icon>
      <div>Image et vidéo</div>
    </button>
  </span>

  <span class="button-row">
    <button
      type="button"
      routerLink="admin/banniere"
      class="bet_time"
      mat-button
      class="white"
    >
      <mat-icon>screen_share</mat-icon>
      <div>Bannière</div>
    </button>
  </span>
  <span class="button-row">
    <button
      type="button"
      routerLink="admin/marque"
      class="bet_time"
      mat-button
      class="white"
    >
      <mat-icon>screen_share</mat-icon>
      <div>Marque</div>
    </button>
  </span>
  <span class="button-row">
    <button
      type="button"
      routerLink="content/manager"
      class="bet_time"
      mat-button
      class="white"
    >
      <mat-icon>filter</mat-icon>
      <div>Gestionnaire de contenu</div>
    </button>
  </span>
  <span class="button-row">
    <button
      type="button"
      routerLink="blogues"
      class="bet_time"
      mat-button
      class="white"
    >
      <mat-icon>comment</mat-icon>
      <div>Blogues</div>
    </button>
  </span>
  <span class="button-row">
    <button
      type="button"
      routerLink="equipe/travail"
      class="bet_time"
      mat-button
      class="white"
    >
      <mat-icon>group</mat-icon>
      <div>Équipe de travail</div>
    </button>
  </span>
  <span class="button-row">
    <button
      type="button"
      routerLink="commandes"
      class="bet_time"
      mat-button
      class="white"
    >
      <mat-icon>list</mat-icon>
      <div>Commandes</div>
    </button>
  </span>
  <span class="button-row">
    <button
      type="button"
      routerLink="instagram"
      class="bet_time"
      mat-button
      class="white"
    >
      <mat-icon>social_distance</mat-icon>
      <div>Instagram</div>
    </button>
  </span>
  <span class="button-row">
    <button
      type="button"
      routerLink="admin/referencement"
      class="bet_time"
      mat-button
      class="white"
    >
      <mat-icon>scale</mat-icon>
      <div>Réferencement</div>
    </button>
  </span>
  <span class="button-row">
    <button
      routerLink="admin/settings"
      type="button"
      class="bet_time"
      mat-button
      class="white"
    >
      <mat-icon>settings</mat-icon>
      <div>Paramétres</div>
    </button>
  </span>
  <span class="button-row">
    <button
      (click)="logout()"
      type="button"
      class="bet_time"
      mat-button
      class="white"
    >
      <mat-icon>logout</mat-icon>
      <div>Déconnexion</div>
    </button>
  </span>
</div>
